module.exports = __webpack_public_path__ + "static/media/Solrock_gaussian2.92d5953d.png";